export default "__VITE_PUBLIC_ASSET__26eb7dfa__"